import React, { useEffect, useState, useRef } from "react";

const ItemLicense = (props) => {
  return (
    <div className="item-cors item-license">
      <h4>{props.data.licensable ? props.data.licensable.title : ""}</h4>
      <span>{props.data.string_date}</span>
      <div className="details">
        <strong>امتیاز من از این کرس : </strong>
        <span>
          {props.data.my_score}
          <i className="icon-favourite2"></i>
        </span>
      </div>
      <div className="grade">
        <span>نمره قبولی آزمون : </span>
        <strong>{props.data.pass_score}</strong>
      </div>
      <a href={props.data.download_link} download>
        دانلود گواهینامه
      </a>
    </div>
  );
};

export default ItemLicense;
